'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _types = require('@appbaseio/reactivecore/lib/utils/types');

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThumbsDownSvg = function ThumbsDownSvg(_ref) {
	var onClick = _ref.onClick,
	    _ref$className = _ref.className,
	    className = _ref$className === undefined ? '' : _ref$className;
	return _react2.default.createElement(
		'svg',
		{
			stroke: 'currentColor',
			fill: 'none',
			strokeWidth: '2',
			viewBox: '0 0 24 24',
			strokeLinecap: 'round',
			strokeLinejoin: 'round',
			className: className,
			height: '1em',
			width: '1em',
			xmlns: 'http://www.w3.org/2000/svg',
			onClick: onClick
		},
		_react2.default.createElement('path', { d: 'M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17' })
	);
};

ThumbsDownSvg.propTypes = {
	onClick: _types2.default.func,
	className: _types2.default.string
};

exports.default = ThumbsDownSvg;